import { useCallback } from 'react';
import {
  BooleanInput,
  Edit,
  FunctionField,
  Labeled,
  SimpleForm,
  TextInput,
} from 'react-admin';
import { Chip } from '@mui/material';

export const SlackNotificationChannelsEdit = () => {
  const transform = useCallback((data: Record<string, unknown>) => {
    const next = { ...data, updatedAt: new Date() };
    const webhook = typeof data.webhookUrl === 'string' ? data.webhookUrl : '';
    if (webhook.startsWith('••••')) {
      delete next.webhookUrl;
    }
    return next;
  }, []);

  return (
    <Edit transform={transform}>
      <SimpleForm>
        <FunctionField
          label="Workflow"
          render={(rec: { workflow?: string }) => (
            <Labeled label="Workflow">
              <Chip label={rec?.workflow ?? ''} />
            </Labeled>
          )}
        />
        <TextInput
          source="webhookUrl"
          label="Workflow webhook URL"
          helperText="Leave masked value unchanged to keep existing URL; paste full URL to replace."
          fullWidth
          type="password"
        />
        <BooleanInput source="enabled" />
      </SimpleForm>
    </Edit>
  );
};
